import type { SignInWithOAuthCredentials } from '@supabase/supabase-js'

export const OAUTH_PROVIDERS = ['google', 'azure'] as const

export type OAuthProvider = (typeof OAUTH_PROVIDERS)[number]

export const OAUTH_PROVIDER_LABELS: Record<OAuthProvider, string> = {
  google: 'Google',
  azure: 'Microsoft',
}

export function isOAuthProvider(value: unknown): value is OAuthProvider {
  return OAUTH_PROVIDERS.includes(value as OAuthProvider)
}

// Supabase rejects an Azure sign-in unless Microsoft returns an email, and
// Microsoft only does so when the `email` scope is requested.
export function oauthSignInCredentials(provider: OAuthProvider, redirectTo: string): SignInWithOAuthCredentials {
  return {
    provider,
    options: provider === 'azure' ? { redirectTo, scopes: 'email' } : { redirectTo },
  }
}
